import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MondelezService } from 'src/app/shared/services/mondelez.service';

@Component({
  selector: 'app-scenario-create-dialog',
  templateUrl: './scenario-create-dialog.component.html',
  styleUrls: ['./scenario-create-dialog.component.scss'],
})
export class ScenarioCreateDialogComponent implements OnInit {
  public scenarioForm: FormGroup;
  public errorMessage: string = '';
  private existingScenarios: any[] = [];

  constructor(
    private mondelezService: MondelezService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ScenarioCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.loadExistingScenarios();
  }

  private createForm() {
    this.scenarioForm = this.fb.group({
      scenario_id: null,
      parent_scenario_id: [this.data.id],
      scenario_name: [null, Validators.required],
      scenario_description: [null, Validators.required],
      created_by: '',
      created_at: '',
      iteration_code: [this.data.iteration_code],
    });
  }

  private loadExistingScenarios() {
    if (this.data.scenarioMasterList.length > 0) {
      this.existingScenarios = this.data.scenarioMasterList
    }
  }

  private isScenarioExists(name: string): boolean {
    let len = this.existingScenarios.filter(scenario => 
      scenario.scenario_name.toLowerCase() === name.trim().toLowerCase()
    );
    return len.length> 0;
  }

  onAddScenario() {
    if (this.scenarioForm.invalid) {
      return;
    }

    if (this.isScenarioExists(this.scenarioForm.value.scenario_name)) {
      this.errorMessage = 'Scenario name already exists. Please choose a different name.';
      return;
    }

    this.mondelezService.createScenario(this.scenarioForm.value).subscribe(
      (res) => {
        if (res['response'] === 'SUCCESS') {
          this.dialogRef.close(true);
        }
      },
      (err) => {
        console.error('Error', err);
      }
    );
  }

  onClose(): void {
    this.dialogRef.close();
  }

  checkExistingScenario(): void {
    if (this.isScenarioExists(this.scenarioForm.value.scenario_name)) {
      this.errorMessage = 'Scenario name already exists. Please choose a different name.';
      return;
    }else{
      this.errorMessage=""
    }
  }
}
